import React from "react"
import Style from './login.module.css'
import { TextField, Grid, Button } from '@mui/material'
import { loginState } from "../../slices/loginSlice"
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from "lodash";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom"
import axios from "axios"
import { LOGIN } from "../../constant/endpoint"
import jwtDecode from "jwt-decode"
const Login = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const login = useSelector(state => state.loginSlice)

    const setLogin = (e) => {
        dispatch(loginState({ name: [e.target.name], value: e.target.value }))
    }
    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }
    const validation = () => {
        let status = true
        if (isEmpty(login.email)) {
            getSweetAlert('error', 'Please fill Email')
            return false
        } else if (isEmpty(login.password)) {
            getSweetAlert('error', 'Please fill Password')
            return false
        }
        return status
    }

    const loginHandle = async () => {
        if (validation()) {
            const response = await axios.post(LOGIN, login)
            if(response?.data?.status === 'success'){
                dispatch(loginState({ name: ['token'], value: response.data.data.token }))
                // navigate('/matchlist')
            }
        }
    }

    return (
        <>
            <Grid container spacing={2} style={{ height: "100vh", textAlign: "center" }}>
                <Grid item xs={6} className={Style.forCenter} >
                    <img className={Style.image} src="https://gamesEx.com/new_script/img/firstss.png"  alt='' />
                </Grid>
                <Grid item xs={6} className={Style.forCenter}>
                    <div className={Style.card}>
                        <h3 style={{ textAlign: "left" }}>Sign in to gameEx Prediction</h3>
                        <TextField name="email" type="text" id="email" label="Email" variant="outlined" onChange={setLogin} />
                        <TextField name="password" type="password" id="password" label="Password" variant="outlined" onChange={setLogin} />
                        <Button onClick={loginHandle} variant="contained">Submit</Button>
                    </div>
                </Grid>
            </Grid>
        </>
    )
}

export default Login

